<template>
    <div
        v-if="$store.state.global.screenWidth > 992"
        class="similar-interesting"
    >
        <SimilarInterestingHeader
            :activeTab="activeTab"
            :titles="titles"
            :issetTabs="issetTabs"
            @changeTab="handlerChangeTab"
        />
        <SimilarSlider
            v-if="activeTab === '#nav-home'"
            :result="similarItems"
        />
        <InterestingSlider
            v-else-if="activeTab === '#nav-profile'"
            :key="activeTab"
            :result="interestingItems"
        />
    </div>
</template>

<script>
import SimilarInterestingHeader from "./SimilarInterestingHeader.vue";
import SimilarSlider from "./SimilarSlider.vue";
import InterestingSlider from "./InterestingSlider.vue";

export default {
    name: 'SimilarInteresting',
  components: {InterestingSlider, SimilarSlider, SimilarInterestingHeader},
    selector: '.similar-interesting',
    props: ['result'],
    data() {
        return {
            titles: this.result.titles,
            activeTab: this.getActiveTab(),
            interestingItems: this.result.interestingItems,
            similarItems: this.result.similarItems,
            issetTabs: {
              similar: Boolean(this.result.similarItems.length),
              interesting: Boolean(this.result.interestingItems.length)
            }
        }
    },
    methods: {
        handlerChangeTab(tab) {
            this.activeTab = tab;
            location.hash = tab;
        },
        getActiveTab() {
          if (this.result.similarItems.length && this.result.interestingItems.length) {
            return location.hash === '#nav-home' || location.hash === '#nav-profile' ? location.hash : '#nav-home'
          } else {
            return this.result.similarItems.length ? '#nav-home' : '#nav-profile';
          }
        }
    }
}
</script>

<style lang="scss" scoped>
.similar-interesting{
    clear: both;
}
</style>